import { render, staticRenderFns } from "./ambassadors.vue?vue&type=template&id=1c24ad5f&scoped=true&"
import script from "./ambassadors.vue?vue&type=script&lang=ts&"
export * from "./ambassadors.vue?vue&type=script&lang=ts&"
import style0 from "./ambassadors.vue?vue&type=style&index=0&id=1c24ad5f&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c24ad5f",
  null
  
)

export default component.exports